import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { IdParam } from '../../models/gen/idParam';
import { OutsourceMemberGetResult } from '../../models/gen/outsourceMemberGetResult';
import { OutsourceMemberSearchParam } from '../../models/gen/outsourceMemberSearchParam';
import { OutsourceMemberSearchResult } from '../../models/gen/outsourceMemberSearchResult';
import { Worker } from '../../models/gen/worker';
import {
  useGenericMutation,
  useGenericQuery,
} from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const OUTSOURCE_MEMBER_CONTEXT_NAMES = {
  POST_OUTSOURCE_MEMBER: 'saveOutsourceMember',
  GET_OUTSOURCE_MEMBER: 'getOutsourceMember',
  DELETE_OUTSOURCE_MEMBER: 'deleteOutsourceMember',
  POST_OUTSOURCE_MEMBER_SEARCH: 'searchOutsourceMember',
} as const;

const apis = apiGenerator();

/**
 * POST `/outsource-member`
 *
 * @param param -
 * @returns
 */
export const usePostOutsourceMember = () =>
  useGenericMutation(async (param: Worker) =>
    apis.post(`${env.BASE_API_ENDPOINT}/outsource-member`, { data: param })
  );

/**
 * GET `/outsource-member/{id}`
 *
 * @param param -
 * @returns
 */
export const useGetOutsourceMember = (param: IdParam) =>
  useGenericQuery(
    [
      OUTSOURCE_MEMBER_CONTEXT_NAMES.GET_OUTSOURCE_MEMBER,
      param as Record<string, unknown>,
    ],
    async (_param) =>
      apis.get<void, OutsourceMemberGetResult>(
        `${env.BASE_API_ENDPOINT}/outsource-member/${param.id}`
      ),
    { enabled: false }
  );

/**
 * GET `/outsource-member/{id}`
 *
 * @param param  -
 * @returns
 */
export const useDeleteOutsourceMember = () =>
  useGenericMutation(async (param: IdParam) =>
    apis.delete(`${env.BASE_API_ENDPOINT}/outsource-member/${param.id}`)
  );

/**
 * POST `/outsource-member/search`
 *
 * @param param -
 * @returns
 */
export const usePostOutsourceMemberSearch = () =>
  useGenericMutation(async (param: OutsourceMemberSearchParam) =>
    apis.post<OutsourceMemberSearchParam, OutsourceMemberSearchResult>(
      `${env.BASE_API_ENDPOINT}/outsource-member/search`,
      { ...queryOptions, data: param }
    )
  );
